// extracted by mini-css-extract-plugin
module.exports = {"licenceBox":"style_licenceBox__HHIph","list":"style_list__3rYUi"};